/**
 * The placeholders a catalog prompt template may use. The catalog validator refuses any other, so an
 * unknown one reaching here is a build defect and is left in place rather than silently blanked.
 */
export const PROMPT_PLACEHOLDERS = {
  fieldLabel: "{{field.label}}",
  fieldId: "{{field.id}}",
  sectionLabel: "{{section.label}}",
  fieldValue: "{{field.value}}",
  /**
   * The causality method. The row passes the pinned field's own display value here, so this
   * placeholder is meaningful only on the method field (`assess_causality`); a template that
   * used it on another field would read that field's value instead.
   */
  method: "{{method}}",
} as const;

/** What `{{method}}` reads when the method field is still empty: the reviewer names it in the composer. */
export const METHOD_NOT_CHOSEN = "the method you name";

/** What a template is expanded with. Values reach only the message text, never the context entry. */
export interface FieldActionPromptInput {
  fieldLabel: string;
  fieldId: string;
  sectionLabel: string;
  /** The field's current display value, quoted into the message where the template asks for it. */
  fieldValue: string;
  /** The causality method as currently chosen on the field, if any. */
  method?: string;
}

function replaceAll(text: string, placeholder: string, replacement: string): string {
  return text.split(placeholder).join(replacement);
}

/** The template with its placeholders expanded; `{{field.value}}` is quoted so it reads as text, not instruction. */
export function expandFieldActionPrompt(template: string, input: FieldActionPromptInput): string {
  let text = template;
  text = replaceAll(text, PROMPT_PLACEHOLDERS.fieldLabel, input.fieldLabel);
  text = replaceAll(text, PROMPT_PLACEHOLDERS.fieldId, input.fieldId);
  text = replaceAll(text, PROMPT_PLACEHOLDERS.sectionLabel, input.sectionLabel);
  text = replaceAll(text, PROMPT_PLACEHOLDERS.fieldValue, JSON.stringify(input.fieldValue));
  text = replaceAll(text, PROMPT_PLACEHOLDERS.method, input.method === undefined || input.method === "" ? METHOD_NOT_CHOSEN : input.method);
  return text;
}
